import React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import QuestionAnswerList from './QuestionAnswerList/QuestionAnswerList';


const ApplicationDetailsList = ({ details }) => {
  if (!details) return null;

  const { id, attributes } = details;

  return (
    <List>
      <ListItem>
        <ListItemText primary="ID" secondary={id || '-'} />
      </ListItem>
      <ListItem>
        <ListItemText primary="Full Name" secondary={attributes?.fullName || '-'} />
      </ListItem>
      <ListItem>
        <ListItemText primary="Email" secondary={attributes?.email || '-'} />
      </ListItem>
      <ListItem>
        <ListItemText primary="Phone" secondary={attributes?.phone || '-'} />
      </ListItem>

      {/* Questions & Answers Section */}
      {Array.isArray(attributes?.questionsAndAnswers) && attributes.questionsAndAnswers.length > 0 && (
        <>
          <Divider sx={{ my: 2 }} />
          <Box px={2} py={1}>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              Questions &amp; Answers
            </Typography>
            <QuestionAnswerList items={attributes.questionsAndAnswers} />
          </Box>
        </>
      )}
    </List>
  );
};

export default ApplicationDetailsList;
